import { render, staticRenderFns } from "./Informasi.vue?vue&type=template&id=42bae205&"
import script from "./Informasi.vue?vue&type=script&lang=js&"
export * from "./Informasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports